export default "__VITE_ASSET__CqzqTuwP__"